var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M16 1a1 1 0 0 1 1 1v1h3a2 2 0 0 1 2 2v15a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5a2 2 0 0 1 2-2h3V2a1 1 0 0 1 2 0v1h6V2a1 1 0 0 1 1-1zm4 8H4v11a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }